// AutoFitView.tsx
import { useEffect } from 'react';
import { useReactFlow } from '@xyflow/react';

type Props = {
  dependencies: any[]; // triggers for fitView, like toggle states
  padding?: number
};

const AutoFitView = ({ dependencies, padding = 0.2 }: Props) => {
  const reactFlowInstance = useReactFlow();

  useEffect(() => {
    const timeout = setTimeout(() => {
      reactFlowInstance.fitView({ padding: padding, duration: 800 });
    }, 300);
    return () => clearTimeout(timeout);
  }, dependencies); // triggers on change

  return null; // this component does not render anything
};

export default AutoFitView;
